<template>
  <div id="cardContentRayonX">

    <div class="mt-3">
      <p> Les entreprises que vous financez émettent <span class="txt_purple">{{ formatEuros(total_esg_carbon_overall) }} </span> Tonnes Co2 / ans </p>
      <p> Scope 1 : <span class="txt_purple">{{ formatEuros(total_esg_carbon_scope1) }} </span> Tonnes Co2 / ans </p>
      <p> Scope 2 : <span class="txt_purple">{{ formatEuros(total_esg_carbon_scope2) }} </span> Tonnes Co2 / ans </p>
      <p> Scope 3 : <span class="txt_purple">{{ formatEuros(total_esg_carbon_scope3) }} </span> Tonnes Co2 / ans </p>
    </div>

    <div class="mt-3" v-if="moreThanAverage">
      Vous emmettez <span class="txt_purple">{{ ratio }} </span> fois plus de CO2 que la moyenne de nos utilisateurs
      <mf_star_rating
        :star=0
        starsize="2x"
      />
    </div>
    <div class="mt-3" v-else>
      Vous emmettez <span class="txt_purple">{{ ratio }} </span> fois moins de CO2 que la moyenne de nos utilisateurs
      <mf_star_rating
        :star="this.starNum"
        starsize="2x"
      />
    </div>
    <div class="mt-3">
      <b-button href="/scan/diagnostic/esg" class="btnCardContent">Analyser l’impact de mon portefeuille</b-button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["average_co2", "average_co2_user", "total_esg_carbon_scope1", "total_esg_carbon_scope2", "total_esg_carbon_scope3", "total_esg_carbon_overall"],
  data() {
    return {
      starNum: 0,
      moreThanAverage: false,
      ratio: 0,
    };
  },
  mounted() {
    if(this.average_co2_user > this.average_co2)
    {
      this.moreThanAverage = true;
      this.ratio = this.$utils.numberWithSpaces(Number(this.average_co2_user / this.average_co2).toFixed(0));
      this.starNum = 0;
    }
    else
    {
      this.moreThanAverage = false;
      this.ratio = this.$utils.numberWithSpaces(Number(this.average_co2 / this.average_co2_user).toFixed(0));

      if(this.ratio > 5)
      {
        this.starNum = 5;
      }
      else if(this.ratio > 3)
      {
        this.starNum = 4;
      }
      else if(this.ratio > 2)
      {
        this.starNum = 3;
      }
      else if(this.ratio > 1.5)
      {
        this.starNum = 2;
      }
      else if(this.ratio > 1.25)
      {
        this.starNum = 1;
      }
    }
    console.log(this.starNum);
  },
  methods: {
    formatEuros(number)
    {
      return this.$utils.numberWithSpaces(Number(number).toFixed(0));
    },
  },
};
</script>
